/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Import_CompleteInputs */

const en_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch import complete.`)
};

const fr_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation par lots terminée.`)
};

const de_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapelimport abgeschlossen.`)
};

const it_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione batch completata.`)
};

const ru_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт пакетов завершен.`)
};

const es_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación por lotes completada.`)
};

const zh_cn2_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导入完成。`)
};

const ja_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括インポートが完了しました。`)
};

const hi_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच आयात पूर्ण हुआ।`)
};

const pt_pt2_batch_import_complete = /** @type {(inputs: Batch_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação em lote concluída.`)
};

/**
* | output |
* | --- |
* | "Batch import complete." |
*
* @param {Batch_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_import_complete = /** @type {((inputs?: Batch_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_import_complete(inputs)
	if (locale === "de") return de_batch_import_complete(inputs)
	if (locale === "it") return it_batch_import_complete(inputs)
	if (locale === "ru") return ru_batch_import_complete(inputs)
	if (locale === "es") return es_batch_import_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_import_complete(inputs)
	if (locale === "ja") return ja_batch_import_complete(inputs)
	if (locale === "hi") return hi_batch_import_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_import_complete(inputs)
	return en_batch_import_complete(inputs)
});